import * as React from 'react';

interface JiraOutlinedIconProps {
    size?: number;
    fillColor?: string;
    style?: React.CSSProperties;
}

const JiraOutlinedIcon = (props: JiraOutlinedIconProps) => {
    const size = props.size ?? 16;
    const fillStyle = { fill: props.fillColor ?? 'none' };
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={1.69}
            style={props.style}
            aria-hidden="true"
        >
            <path
                style={fillStyle}
                d="M19.0014 3.46716C19.4001 3.4672 19.7829 3.61361 20.0649 3.90466C20.343 4.19194 20.474 4.56815 20.4741 4.94275V13.183H19.6284C18.4644 13.1829 17.4617 12.7034 16.7621 11.8822C16.0719 11.0718 15.7143 9.97616 15.7143 8.77576V8.26794H15.1928C13.9923 8.26794 12.8993 7.89931 12.0942 7.19763C11.2803 6.48816 10.808 5.47681 10.808 4.31189V3.46716H19.0014Z"
            />
            <path
                style={fillStyle}
                d="M15.3495 7.14191C15.7246 7.14194 16.1069 7.26639 16.4013 7.54816C16.6997 7.83376 16.8436 8.22032 16.8437 8.61749V16.8577H15.999C14.836 16.8577 13.8287 16.3796 13.124 15.5609C12.4275 14.7516 12.0624 13.6547 12.0624 12.4505V11.9202H11.541C10.3443 11.9202 9.25256 11.5591 8.44623 10.8636C7.62979 10.1593 7.15619 9.15258 7.15619 7.98663V7.14191H15.3495Z"
            />
            <path
                style={fillStyle}
                d="M11.7201 10.7941C12.1195 10.7942 12.5063 10.9409 12.7904 11.2414C13.0698 11.5369 13.1927 11.919 13.1927 12.2922V20.5324H12.347C11.1831 20.5323 10.1804 20.0528 9.48083 19.2316C8.79054 18.4212 8.43298 17.3256 8.43298 16.1252V15.5949H7.9115C6.711 15.5949 5.618 15.2263 4.81287 14.5246C3.99895 13.8151 3.52673 12.8038 3.52673 11.6389V10.7941H11.7201Z"
            />
        </svg>
    );
};

export default JiraOutlinedIcon;
